import { IAppointment } from '../interface/appointment';
export class Appointment implements IAppointment {
    constructor(
        public AppointmentId : number,   
        public AppointmentDoctorId : number,   
        public AppointmentDoctorName : string,   
        public AppointmentSlotId: number,   
        public AppointmentSlotDescription: string,   
        public AppointmentClinicId   : number,   
        public AppointmentClinicName : string,        
        public AppointmentPatientId   : number,   
        public AppointmentPatientName: string,   
        public AppointmentPatientMail: string,   
        public AppointmentPatientContactNo: number,   
        public AppointmentDay: string,   
        public AppointmentTime: string,   
        public AppointmentUserIP: string,   
        public AppointmentServiceId: number,   
        public AppointmentServiceName: string,   
        public AppointmentIsBooked: boolean,   
        public AppointmentBookedDate: string,   
        public AppointmentIsCancelled: boolean,   
        public AppointmentCancelledDate: string ,  
        public AppointmentScheduleEnterBy: string,   
        public AppointmentAddedBy: string,   
        public AppointmentScheduleEnterDate: string,   
        public AppointmentAddedDate: string ,  
        public AppointmentIsScheduledActive: boolean,   
        public IsAppointmentActive: boolean, public DoctorColorCode: string, public BookingAmount: number, public IsComplete?: number, public OrderNo?: string, public AppointmentIsCompleted?: number, public IsPastAppointment?:number, public Status?:number,public IsRefundRequired?:boolean ){

    }
}

export class Schedule {
    constructor(
        public StartDate : string,
        public EndDate : string,
        public AppointmentSchedule : Appointment[],
        public isMonday : boolean,
        public isTuesday : boolean,
        public isWedneday : boolean,
        public isThursday : boolean,
        public isFriday : boolean,
        public isSaturday : boolean,
        public isSunday : boolean, public Day? : string,  public DoctorId? : number, public ClinicId? : number, public SlotId?: number, public SlotDescription?: string,public BookingAmount?: number){}
}

export class Reschedule {
    constructor(
        public RescheduleDay : string,
        public RescheduleTime : string,
        public Appointment : Appointment){}
}


// WEBPACK FOOTER //
// ./src/app/section/appointment/model/appointment.ts